var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonalFeedChipIcon = function SvgPersonalFeedChipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#638FFF",
    d: "m7.917 4.25 1.178 2.988 2.988 1.179-2.988 1.178-1.178 2.988-1.179-2.988L3.75 8.417l2.988-1.179z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#638FFF",
    d: "M7.917 3.833c.17 0 .325.105.387.264l1.112 2.82 2.82 1.112a.417.417 0 0 1 0 .775l-2.82 1.112-1.112 2.82a.417.417 0 0 1-.775 0l-1.112-2.82-2.82-1.112a.417.417 0 0 1 0-.775l2.82-1.112 1.112-2.82a.42.42 0 0 1 .388-.264m0 1.553L7.126 7.39a.42.42 0 0 1-.235.235l-2.005.79 2.005.792a.42.42 0 0 1 .235.234l.79 2.006.792-2.006a.42.42 0 0 1 .234-.234l2.006-.791-2.006-.791a.42.42 0 0 1-.234-.235zM4.167 3l.53 1.136 1.136.53-1.136.531-.53 1.136-.53-1.136-1.137-.53 1.136-.53z"
  })));
};
export default SvgPersonalFeedChipIcon;